<script context="module" lang="ts">
  export function authorizationCheck(authName: string): boolean {
    const rootScope = window["$rootScope"] || false;
    const user = rootScope && rootScope.user;
    const policy = rootScope.policies ? rootScope.policies[authName] : false;

    if (!policy || !user) return false;
    if (user.is_admin) return true;

    return policy.includes(
      user.role ||
        user.distributors[0]?.role ||
        user.manufacturer?.role ||
        user.manufacturers[0]?.role,
    );
  }
</script>
